function closeModal(event) {
  event.target.closest('dialog').close();
  window.sessionStorage.setItem('ModalClosed', true);
}

document.addEventListener('DOMContentLoaded', function () {
  const popUpNewsletter = document.querySelector('dialog#SignUpModal');
  const popUpNewslettercloseButton = popUpNewsletter.querySelector('.popup__close');
  if (window.sessionStorage.getItem('ModalClosed') != 'true' && window.location.href != 'https://subsun.com/products/sub-sun-x-joel-gion') {
    setTimeout(function (){
      popUpNewsletter.showModal();        
    }, 15000);
  }
  popUpNewslettercloseButton.addEventListener('click', closeModal);
});
